
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Force le rechargement complet si une nouvelle version est déployée
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
    }
  });
}

// Vide le cache du navigateur
if (window.caches) {
  caches.keys().then(function(names) {
    for (let name of names) {
      caches.delete(name);
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
